import { assetFolders, zIndex } from 'common/constants'
import { gridBreakPoints } from 'common/theme'
import styled, { css, keyframes } from 'styled-components'
import { StyledMainNav, StyledNavBar } from './NavBar.styled'

export interface StickyProp {
  isSticky?: boolean
  assetFolder?: string
  isSRP?: boolean
}
export const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

export const StyledBody = styled.div`
  flex-grow: 1;
`

export const StyledHeader = styled.div<StickyProp>`
  width: 100%;
  height: ${({ isSticky }) => (isSticky ? '6rem' : '10rem')};
  background-color: ${({ isSticky, theme }) => (isSticky ? theme.colors.primary : null)};
  ${({ isSticky, assetFolder }) =>
    isSticky &&
    css`
      top: 0;
      z-index: ${zIndex.header};
      max-height: 6rem;
      background-color: ${({ theme }) => {
        return theme.headerSticky.backgroundColor
      }};
    `}
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${({ isSticky }) => (isSticky ? headerAnimation : null)};
  border-bottom: ${({ isSRP, isSticky, theme }) =>
    isSRP || isSticky ? 'none' : `0.1rem solid ${theme.colors.secondary}`};
`

const curtainEffect = keyframes`
  from {
    transform: translateY(-15rem);
  }
`
export const headerAnimation = css`
  animation: ${curtainEffect} 0.6s ease-in-out;
`
export const StyledBranding = styled.div<StickyProp>`
  display: flex;
  // justify-content: space-between;
  align-items: center;
  // flex-grow: 1;
  max-height: 12rem;
  height: 100%;
  padding-left: 2.75rem;
  ${({ assetFolder }) =>
    assetFolder === assetFolders.Infiniti &&
    css`
      padding-left: 0;
    `}
  a {
    height: 100%;
  }

  img {
    height: 7rem;
    transform: translateY(1.1rem);

    ${({ assetFolder }) => {
      switch (assetFolder) {
        case assetFolders.Nissan:
          return css`
            transform: translateY(1.1rem) translateX(0.7rem);
          `
        case assetFolders.Infiniti:
          return css`
            transform: translateY(1.5rem) translateX(0.6rem);
            @media (max-width: ${gridBreakPoints.xl}) {
              height: 4.7rem;
              transform: translateY(2.4rem) translateX(0.6rem);
            }
          `
        case assetFolders.Independent:
          return css`
            height: 9rem;
            transform: translateY(0.3rem) translateX(0.6rem);
          `
        default:
          return css`
            transform: translateX(0.7rem);
          `
      }
    }}

    ${({ isSticky, assetFolder }) => {
      if (isSticky) {
        switch (assetFolder) {
          case assetFolders.Nissan:
            return css`
              height: 90%;
              transform: translateY(0.3rem) translateX(0.6rem);
            `
          case assetFolders.Infiniti:
            return css`
              height: 8rem;
              transform: translateY(-1.5rem) translateX(1.1rem);
              @media (max-width: ${gridBreakPoints.xl}) {
                height: 7rem;
                transform: translateY(-1rem) translateX(1.1rem);
              }
            `
          case assetFolders.Independent:
            return css`
              height: 5.5rem;
              transform: translateY(-0.7rem) translateX(0.4rem);
            `
          default:
            return null
        }
      }
    }}
  }

  @media (max-width: ${gridBreakPoints.lg}) {
    border-bottom: unset;
  }

  ${({ isSticky }) =>
    isSticky
      ? css`
          border-bottom: none;
          @media (max-width: ${gridBreakPoints.lg}) {
            justify-content: center;
          }
        `
      : css`
          //padding: 2.75rem 2.75rem 1.75rem;
          /* border-bottom: 0.1rem solid ${({ theme }) => theme.colors.secondary}; */
        `}
`
export const StyledMenuHeader = styled.div.attrs({
  className: 'container-fluid'
})`
  font-family: ${({ theme }) => theme.fonts.fontRegular};
  display: flex;
  justify-content: space-between;
  padding: 0 3rem;

  @media (min-width: ${gridBreakPoints.lg}) {
    ${StyledNavBar} {
      ${StyledMainNav} {
        .nav .nav-item:first-child > .nav-link {
          padding-left: 0;
          margin-left: 0;
        }
      }
    }
  }

  @media (max-width: ${gridBreakPoints.lg}) {
    position: absolute;
    top: 0;
  }
`

export const StyledBurgerButton = styled.div<StickyProp>`
  width: 3.6rem;
  height: 3.6rem;
  display: none;
  margin-right: 2rem;

  z-index: 100;
  button {
    width: 100%;
    height: 100%;
    border: none;
    background-color: transparent;
    svg {
      fill: ${({ isSticky }) => (isSticky ? '#e5e6e4' : 'rgba(0, 0, 0, 0.2)')};
    }
    &:hover > svg {
      transition: all 200ms ease-in;
      fill: ${({ isSticky }) => (isSticky ? '#fff' : 'rgba(0, 0, 0, 0.5)')};
    }
  }

  @media (max-width: ${gridBreakPoints.lg}) {
    display: block;
  }
`
